<template>
  <main></main>
</template>

<script>
import Cookies from "js-cookie";
import { getParentSiteBase } from "@/helper/util_custom";
import { preSchoolsDropdown } from "@/pages/application/data";
export default {
  mounted() {
    const school = Cookies.get("userSchoolNameSession");
	  const schID = Cookies.get("schoolSession");
    const isPreschool = Object.values(preSchoolsDropdown).includes(schID);
    const isMiddleton = school?.includes('Middleton');
	  let location;
		switch (school.toLowerCase()){
			case "claymore":
				location = `${getParentSiteBase()}/Public/StudentApplicationForm_Claymore`;
				break;
			default:
				location = `${getParentSiteBase()}/Public/StudentApplicationForm`;
				break;
		}
    if (isPreschool) {
      location = `${getParentSiteBase()}/Public/PreschoolStudentApplicationForm`;
    }
    if (isMiddleton) {
      location = `${getParentSiteBase()}/Public/MisStudentApplicationForm`;
    }
	  window.open(location, '_blank');
  }
}
</script>